import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "@/utils/motionVariants";

/**
 * AI-search extraction block. First sentence answers the query intent
 * directly (entity-first, ~35–45 words) and is marked up as a plain
 * paragraph immediately after a question-form H2 so answer engines can
 * lift it verbatim.
 */
export default function QuickAnswerBlock({ heading, answer, supporting, testId }) {
  return (
    <section className="py-14 md:py-16 bg-white" data-testid={testId || "quick-answer"}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial="hidden" whileInView="visible" viewport={viewportOnce} variants={fadeUp}>
          <h2 className="font-heading text-2xl sm:text-3xl font-bold text-brand-black tracking-tight mb-4">{heading}</h2>
          <p className="text-lg text-brand-black leading-relaxed font-medium mb-4">{answer}</p>
          {supporting && <p className="text-base text-brand-grey leading-relaxed">{supporting}</p>}
        </motion.div>
      </div>
    </section>
  );
}
